import React, {Fragment} from "react";
import Header from "../../components/header/Header";
import Hero from "../../components/hero/hero";
import PartnerSection from "../../components/PartnerSection";
import About from "../../components/about/about";
import SolutionSection from "../../components/SolutionSection/SolutionSection";
import ContactInfoSection from "../../components/ContactInfoSection/ContactInfoSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const HomePage = () => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <Hero />
          <PartnerSection />
          <About />
          <SolutionSection />
          <ContactInfoSection />
          <Scrollbar />
        </main>
        <Footer />
      </div>
    </Fragment>
  );
};
export default HomePage;
